<template>
  <div class="over" style="width: 100%; height: 100%">
    <img
      id="myImg"
      v-bind:src="require(`@/${this.src}`)"
      :alt="title"
      v-on:click="expand($event)"
      transition="expand-transition"
      style="width: 100%; height: 100%"
    />
  </div>
  <div id="myModal-2" class="modal-2">
    <span class="close-2">&times;</span>
    <img class="modal-content-2" id="img01-2" />
    <div id="caption2"></div>
  </div>
</template>

<script>
export default {
  props: ["src", "title"],
  data() {
    return {
      show: true
    };
  },
  methods: {
    expand(val) {
      var modal = document.getElementById("myModal-2");
      var modalImg = document.getElementById("img01-2");
      var captionText = document.getElementById("caption2");

      modal.style.display = "block";
      modalImg.src = val.target.src;
      captionText.innerHTML = val.target.alt;

      // Get the <span> element that closes the modal
      var span = document.getElementsByClassName("close-2")[0];

      // When the user clicks on <span> (x), close the modal
      span.onclick = function() {
        modal.style.display = "none";
      };
    }
  }
};
</script>

<style  >
.over {
  overflow: hidden;
}
#myImg {
  cursor: pointer;
  transition: 0.3s;
  object-fit: cover;
  object-position: center top;
 
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: 2s ease-in-out;
  transition: 2s ease-in-out;
}
#myImg:hover {
  -webkit-transform: scale(1.5);
  transform: scale(1.5);
}
/* #myImg:hover {
    filter: blur(2px);
  -webkit-filter: blur(2px);
  
  
} */

/* The Modal (background) */
.modal-2 {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content-2 {
  margin: auto;
  display: block;
  max-height: 80%;
  /* max-width: 700px; */
}

/* Caption of Modal Image */
#caption2 {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation */
.modal-content-2,
#caption2 {
  -webkit-animation-name: zoom2;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom2;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom2 {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom2 {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close-2 {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close-2:hover,
.close-2:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content-2 {
    /* width: 100%; */
    max-height: 70%;
    max-width: 100%;
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>